import { useStore } from "react-admin";
import FloorMap from "./FloorMap";
import RoomsTable from "./RoomsTable";

const VIEW_STORE_KEY = "dormitoryRooms.view";

const ListRooms = () => {
  const [view, setView] = useStore(VIEW_STORE_KEY, "map");

  if (view === "table") {
    return <RoomsTable onShowMap={() => setView("map")} />;
  }

  return <FloorMap onShowTable={() => setView("table")} />;
};

export default ListRooms;
